<div class="workSpace">
  <div class="headersTab">
    <div class="w3-caja-menu padreizquierda w3-veinte">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal">
          <b>{{ "menu." + dataService.moduleSelect | translate }} </b>
        </span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal">
          {{ "menu." + dataService.subModuleSelect | translate }}
        </span>
      </div>
    </div>

    <div class="w3-rest">
      <div class="w3-noventa2 w3-row">
        <div class="w3-third padreizquierda">
          <app-filters
            [name]="'filtros.anio' | translate"
            [array]="yearsAvailable"
            [typeFilter]="Filters.YEAR"
            [click]="false"
            (eventClick)="yearChange($event)"
          >
          </app-filters>
        </div>

        <!-- MESES -->
        <div class="w3-third padreizquierda">
          <app-filters
            [name]="'filtros.mes' | translate"
            [array]="monthOfYearAvailable"
            [typeFilter]="Filters.MOUNTH"
            (eventClick)="monthChange($event)"
            [click]="false"
          >
          </app-filters>
        </div>
        <!-- FIN MESES -->
        <div class="w3-third padreizquierda">
          <app-filters
            [name]="'filtros.sucursales' | translate"
            [array]="sucursales"
            [typeFilter]="Filters.SUCURSALES"
            [click]="false"
            [consolidado]="consolidado"
            (eventClick)="agencyChange($event)"
          >
          </app-filters>
        </div>
      </div>
      <div class="w3-rest w3-right " style="margin-top: 14px;">
        <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" (click)="resetFilters()"
          matTooltip="{{'tooltips.borrar-filtros'|translate}}">
          <img src="./../../../../assets/img/eraser.png">
        </div>
        <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menu">
          more_vert
        </mat-icon>
        <mat-menu #menu="matMenu">
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarPDF()">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar'|translate}}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
  <div class="workSpaceTab">
    <!-- Graficas -->
    <div class="w3-row" style="height: 50%;">
      <div class="zonaGraficas">
        <div class="grafica">
          <app-graficas
            [data]="data1"
            [type]="types.DONUT"
            [labels]="labels1"
            [axisY]="axisY1"
            [tituloZona]="tituloZona1"
            [graphicsAvaibable]="graphics1"
            [zona]="zona1"
            [subTituloZona]="subtitles"
            [colors]="['#004A97']"
            (eventClick)="clickGrafic($event, 1)"
          >
          </app-graficas>
        </div>
      </div>
      <div class="zonaGraficas">
        <div class="grafica">
          <app-graficas
            [data]="data2"
            [type]="types.HEATMAP"
            [labels]="labels2"
            [axisY]="axisY2"
            [tituloZona]="tituloZona2"
            [graphicsAvaibable]="graphics2"
            [zona]="zona2"
            [subTituloZona]="subtitles"
            [colors]="['#68B4D6']"
            (eventClick)="clickGrafic($event, 2)"
          >
          </app-graficas>
        </div>
      </div>
      <div class="zonaGraficas">
        <div class="grafica">
          <app-graficas
            [data]="data3"
            [type]="types.DONUT"
            [labels]="labels3"
            [axisY]="axisY3"
            [tituloZona]="tituloZona3"
            [graphicsAvaibable]="graphics3"
            [zona]="zona3"
            [subTituloZona]="subtitles"
            [colors]="['#82CC60']"
            (eventClick)="clickGrafic($event, 3)"
          >
          </app-graficas>
        </div>
      </div>
    </div>
    <div class="w3-row" style="height: 50%;">
      <div class="zonaGraficas">
        <div class="grafica">
          <app-graficas
            [data]="data4"
            [type]="types.BAR"
            [labels]="labels4"
            [axisY]="axisY4"
            [tituloZona]="tituloZona4"
            [graphicsAvaibable]="graphics4"
            [zona]="zona4"
            [subTituloZona]="subtitles"
            [colors]="['#FFCB03']"

            (eventClick)="clickGrafic($event, 4)"
          >
          </app-graficas>
        </div>
      </div>
      <div class="zonaGraficas">
        <div class="grafica">
          <app-graficas
            [data]="data5"
            [type]="types.DONUT"
            [labels]="labels5"
            [axisY]="axisY5"
            [tituloZona]="tituloZona5"
            [graphicsAvaibable]="graphics5"
            [zona]="zona5"
            [subTituloZona]="subtitles"
            [colors]="['#FC8A33', '#F74C58']"
            (eventClick)="clickGrafic($event, 5)"
          >
          </app-graficas>
        </div>
      </div>
      <div class="zonaGraficas">
        <div class="grafica">
          <app-graficas
            [data]="data6"
            [type]="types.BAR"
            [labels]="labels6"
            [axisY]="axisY6"
            [tituloZona]="tituloZona6"
            [graphicsAvaibable]="graphics6"
            [zona]="zona6"
            [subTituloZona]="subtitles"
            [colors]="['#F74C58']"
            (eventClick)="clickGrafic($event, 6)"
          >
          </app-graficas>
        </div>
      </div>
    </div>
  </div>
</div>
